<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">预警报警情况</div>
    </div>
    <el-tabs v-model="radio" @tab-click="handleClick">
      <el-tab-pane label="未处理" name="0"></el-tab-pane>
      <el-tab-pane label="已复位" name="1"></el-tab-pane>
      <el-tab-pane label="异常" name="2"></el-tab-pane>
    </el-tabs>
    <div class="modul-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="桥梁名称">
          <el-select
            v-model="bridgeName"
            @change="bridgeChange"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select
            v-model="equipmentType"
            @change="equipmentTypeChange"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in equipmentTypes"
              :key="index"
              :label="item.equipmentTypeName"
              :value="item.equipmentTypeUuid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="timeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          ><el-button type="primary" @click="getSetUpEarlyWarning()"
            >查询</el-button
          ><el-button @click="onExport">导出</el-button></el-form-item
        >
        <!-- <br>
				<el-form-item>
					<el-radio-group v-model="radio">
						<el-radio :label="0">未处理</el-radio>
						<el-radio :label="1">已复位</el-radio>
						<el-radio :label="2">已完成</el-radio>
					</el-radio-group>
				</el-form-item> -->
      </el-form>
      <!-- <el-form :inline="true">
        <el-form-item
          ><el-button @click="onExport">导出</el-button></el-form-item
        >
      </el-form> -->
    </div>
    <div class="modul-content">
      <div class="table-box">
        <el-table
          v-loading="loading"
          :data="tableData"
          :header-cell-style="{'text-align': 'left'}"
          :cell-style="{'text-align': 'left'}"
          max-height="500"
          border
          style="width: 100%"
        >
          <el-table-column
            label="编号"
            type="index"
            width="80px"
          ></el-table-column>
          <el-table-column
            label="桥梁名称"
            prop="bridgeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="设备类型"
            prop="equipmentTypeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="数据类型"
            prop="dataTypeName"
            width="100px"
          ></el-table-column>
          <el-table-column
            label="设备别名"
            prop="equipmentAnotherName"
          ></el-table-column>
          <el-table-column label="预警时间" prop="createTime">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.createTime == null ? '————' : scope.row.createTime
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="预警值">
            <template #default="scope">
              <div class="warning-value" style="justify-content: flex-start">
                <div id="">{{ scope.row.beginWarningValue }}</div>
                <div class="input-line"></div>
                <div id="">{{ scope.row.endWarningValue }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="预警等级">
            <template #default="scope">
              <div class="warning-value" style="justify-content: flex-start">
                <div
                  id=""
                  :style="{
                    color: warningLevelStyle[calcWarningLevel(scope.row)]
                  }"
                >
                  {{ calcWarningLevel(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="读值" prop="dataValue">
            <template #default="scope">
              <div
                :style="{
                  display: 'flex',
                  justifyContent: ' flex-start',
                  alignItems: 'baseline',
                  color: warningLevelStyle[calcWarningLevel(scope.row)]
                }"
              >
                <i
                  class="el-icon-top"
                  v-if="scope.row.dataValue > scope.row.endWarningValue"
                ></i>
                <i
                  v-else-if="scope.row.dataValue < scope.row.beginWarningValue"
                  class="el-icon-bottom"
                ></i>
                <div>{{ scope.row.dataValue }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="告警现场图"
            prop="state"
            v-if="radio == '0' ? false : true"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.warnComponentImg">
                <el-carousel>
                  <el-carousel-item
                    v-for="(item, index) in scope.row.warnComponentImg.split(
                      ','
                    )"
                    :key="index"
                  >
                    <el-image
                      width="40"
                      :src="item"
                      :preview-src-list="scope.row.warnComponentImg.split(',')"
                      fit="cover"
                      class="bridge-image"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            prop="state"
            v-if="radio == '0' ? false : true"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.state == 0
                    ? '待处理'
                    : scope.row.state == 1
                    ? '已复位'
                    : scope.row.state == 2
                    ? '异常'
                    : '未知'
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="处理结果"
            prop="handlingInformation"
            v-if="radio == '0' ? false : true"
          ></el-table-column>
          <el-table-column label="操作" v-if="radio == '0' ? true : false">
            <template slot-scope="scope">
              <el-button @click="operate(scope.row)" type="text" size="small"
                >去处理</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 点击处理弹出框 -->
    <div
      class="caozuotianbiao"
      :style="caozuoxy == true ? 'display: none;' : ''"
    >
      <el-form
        class="caozuotianbiao-from"
        label-width="80px"
        label-position="left"
        style="
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-content: center;
        "
      >
        <div class="modul-top" style="position: absolute; top: 5px">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">报警处理</div>
        </div>
        <div
          class="caidan-img"
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="modal-item" style="margin-top: 40px">
          <div :span="11">
            <el-form-item label="桥梁名称">{{
              dispose.bridgeName
            }}</el-form-item>
          </div>
          <div :span="11">
            <el-form-item label="设备类型">{{
              dispose.equipmentTypeName
            }}</el-form-item>
          </div>
        </div>
        <div class="modal-item">
          <div :span="11">
            <el-form-item label="设备名称">{{
              dispose.equipmentName
            }}</el-form-item>
          </div>
          <div :span="11">
            <el-form-item label="预警时间">
              <div>
                {{ dispose.createTime == null ? '————' : dispose.createTime }}
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="modal-item">
          <div :span="11">
            <el-form-item label="预警值">
              <div class="warning-value" style="justify-content: flex-start">
                <div id="">{{ dispose.beginWarningValue }}</div>
                <div class="input-line"></div>
                <div id="">{{ dispose.endWarningValue }}</div>
              </div>
            </el-form-item>
          </div>
          <div :span="11">
            <el-form-item label="读值">{{ dispose.dataValue }}</el-form-item>
          </div>
          <!-- <div :span="11">
            <el-form-item label="读值">{{ dispose.dataValue }}</el-form-item>
          </div> -->
        </div>
        <el-form-item label="报警操作">
          <el-radio-group v-model="radios">
            <el-radio :label="1">复位</el-radio>
            <el-radio :label="2">异常</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="告警现场图" style="width: 90%">
          <!-- <el-input
            type="text"
            rows="5"
            v-model="warnComponentImg"
            placeholder="请输入理由"
          ></el-input> -->
          <img-upload
            class="upload-margin"
            :imageUrl="warnComponentImg"
            ref="bridgeSidePictureUrl"
            :limit="10"
          ></img-upload>
        </el-form-item>
        <el-form-item label="解决方案" style="width: 90%"
          ><el-input
            type="textarea"
            rows="5"
            v-model="solution"
            placeholder="请输入解决方案"
          ></el-input
        ></el-form-item>
        <el-form-item label="处理结果" style="width: 90%"
          ><el-input
            type="textarea"
            rows="5"
            v-model="radiosText"
            placeholder="请输入理由"
          ></el-input
        ></el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="quxiao">取消</el-button>
          <el-button type="primary" @click="isOK">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import imgUpload from '@/views/components/upLoad/imgUpload.vue'
export default {
  name: 'yujingbaojingqingkuang',
  components: {
    imgUpload
  },
  data() {
    return {
      addVisible: false,
      bridgeData: [],
      bridgeName: '',
      equipmentType: '',
      equipmentTypes: [],
      time: [
        this.$moment().subtract(1, 'h').format('YYYY-MM-DD HH:mm:ss'),
        this.$moment().format('YYYY-MM-DD HH:mm:ss')
      ],
      // time: [new Date(this.$moment().subtract(1, 'h')), new Date(this.$moment())],
      formInline: {
        bridgeUuid: '',
        equipmentTypeUuid: '',
        beginTime: '',
        endTime: '',
        beginTime: this.$moment()
          .subtract(1, 'h')
          .format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        pageSize: 10,
        pageNum: 1, //当前页数
        state: 0 //处理状态
      },
      total: 1,
      // 表格
      loading: true,
      tableData: [],
      radio: '0',
      caozuoxy: true,
      radios: 1,
      radiosText: '',
      solution: '', //解决方案
      warnComponentImg: [],
      dispose: {},
      warningLevelStyle: {
        红色预警: '#FF3800',
        橙色预警: '#FFA500',
        黄色预警: '#FF8000',
        蓝色预警: '#0000FF'
      },
      deviceTypeValeRatio: [
        {
          equipmentTypeName: '桥面线性',
          range: ['min', 'max'],
          rate: [
            {
              level: '橙色预警',
              val: 1
            },
            {
              level: '红色预警',
              val: 1.25
            }
          ]
        },
        {
          equipmentTypeName: '索力加速度计',
          range: ['max'],
          rate: [
            {
              level: '蓝色预警',
              val: 1
            },
            {
              level: '黄色预警',
              val: 1.09
            },
            {
              level: '橙色预警',
              val: 1.18
            },
            {
              level: '红色预警',
              val: 1.27
            }
          ]
        },
        {
          equipmentTypeName: 'GNSS',
          range: ['min', 'max'],
          rate: [
            {
              level: '蓝色预警',
              val: 1
            },
            {
              level: '黄色预警',
              val: 1.27
            },
            {
              level: '橙色预警',
              val: 1.54
            },
            {
              level: '红色预警',
              val: 1.81
            }
          ]
        }
      ]
    }
  },

  async mounted() {
    // 获取-桥梁录入信息
    this.getBiBridgeBoPage()
    // 获取预警报警情况列表
    this.getSetUpEarlyWarning()
    // console.log(this.formInline);
  },
  watch: {
    path(one, two) {
      this.formInline = {}
      // console.log(one, two);
      // this.tableReq();
    }
    // radio(one, two) {
    // 	this.formInline.state=one
    // 	this.xuan(one)
    // 	this.getSetUpEarlyWarning()
    // }
  },
  computed: {
    path() {
      return this.$route.path
    },
    api() {
      return this.$config.host
    }
  },
  methods: {
    calcWarningLevel(item) {
      let {equipmentTypeName, beginWarningValue, endWarningValue, dataValue} =
        item
      let ratioItem = this.deviceTypeValeRatio.find(
        (item) => item.equipmentTypeName === equipmentTypeName
      )
      if (!ratioItem) {
        return '红色预警'
      }
      let {range, rate} = ratioItem

      let i
      let level = ''
      for (i = 0; i < rate.length; i++) {
        console.log(
          '%c [ rate[i] ]-497',
          'font-size:13px; background:pink; color:#bf2c9f;',
          rate[i].val
        )
        if (dataValue > endWarningValue && range.includes('max')) {
          if (Math.abs(dataValue) > Math.abs(endWarningValue * rate[i].val)) {
            level = rate[i].level
          }
        } else if (dataValue < beginWarningValue && range.includes('min')) {
          if (Math.abs(dataValue) > Math.abs(beginWarningValue * rate[i].val)) {
            level = rate[i].level
          }
        }
      }
      return level || '红色预警'
    },
    //tab切换
    handleClick(one, two) {
      // console.log(one.index);
      this.formInline.state = Number(one.index)
      this.getSetUpEarlyWarning()
    },
    // 时间选择
    timeChange(e) {
      let time = JSON.parse(JSON.stringify(e))
      if (time != undefined && time.length > 0) {
        this.formInline.beginTime = time[0]
        this.formInline.endTime = time[1]
      } else {
        this.formInline.beginTime = ''
        this.formInline.endTime = ''
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.getSetUpEarlyWarning(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.getSetUpEarlyWarning()
    },
    // 桥梁名称选择
    async bridgeChange(e) {
      this.formInline.bridgeUuid = e
      this.equipmentType = ''
      ///biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid
      ///biBridge/getBridgeEquipmentTypeScreenList
      const res = await this.$api.sendGet(
        '/biBridge/getBridgeEquipmentTypeScreenList',
        {
          bridgeUuid: e
        }
      )
      console.log('设备类型', res)
      if (res.errcode === 0) {
        this.equipmentTypes = res.data
      } else {
        this.equipmentTypes = []
      }
    },
    // 设备类型选择
    async equipmentTypeChange(e) {
      console.log(
        '%c [ e ]-296',
        'font-size:13px; background:pink; color:#bf2c9f;',
        e
      )
      this.formInline.equipmentTypeUuid = e
    },
    // 获取-桥梁名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      console.log('桥梁名称', res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list
        } else {
          this.bridgeData = []
        }
      }
    },
    // 获取预警报警情况列表
    async getSetUpEarlyWarning(num) {
      // console.log('请求体',this.formInline);
      num
        ? (this.formInline.pageNum = num)
        : (this.formInline.pageNum = this.formInline.pageNum)
      this.loading = true
      console.log(this.formInline)
      const res = await this.$api.sendPost(
        '/earlyWarning/getAllEarlyWarningAlarm',
        this.formInline
      )
      console.log('数据', res)
      this.loading = false
      if (res.errcode === 0) {
        this.tableData = res.data.list
        this.total = res.data.total
      } else {
        this.tableData = []
        this.total = 1
      }
    },
    //操作按钮
    operate(data) {
      this.caozuoxy = false
      ;(this.dispose = data), console.log(this.dispose)
    },
    async isOK() {
      console.log('确认修改')
      this.caozuoxy = true
      let data = {
        equipmentUuid: this.dispose.equipmentUuid,
        handlingInformation: this.radiosText,
        id: this.dispose.id,
        state: Number(this.radios),
        solution: this.solution,
        warnComponentImg: this.warnComponentImg
          .map((subitem) => subitem.url)
          .join(',')
      }
      console.log(data)
      this.loading = true
      const res = await this.$api.sendPost('/earlyWarning/update', data)
      console.log('状态', res)
      this.loading = false
      if (res.errcode === 0) {
        this.getSetUpEarlyWarning()
        console.log('修改状态', res)
      } else {
      }
    },
    quxiao() {
      console.log('取消')
      this.caozuoxy = true
    },
    //tab切换
    xuan(chu) {},
    //导出
    async onExport() {
      let data = {
        ...this.formInline
      }
      // let { pageNum, pageSize, ...data } = this.formInline
      const res = await this.$api.sendDownload('/earlyWarning/export', data)
      console.log('res', res)
      let fileName = '预警报警'
      let blobObject = new Blob([res], {
        type: 'application/vnd.ms-excel,charset=utf-8'
      }) //如果是字节流
      //是IE浏览器
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.navigator.msSaveOrOpenBlob(blobObject, fileName)
      } else {
        //火狐谷歌都兼容
        //模板中要有一个预定义好的a标签
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blobObject) //如果是字节流
        link.target = '_blank'
        link.download = fileName
        link.click()
        //释放内存
        window.URL.revokeObjectURL(link.href)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modul-search {
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modul-content-title {
  // margin: 20px 0;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-line {
  margin: 0 10px;
  width: 50px;
  border-bottom: 1px solid #999999;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  position: relative;
  text-align: left;
  width: 70%;
  // height: 800px;
  // overflow: auto;
  background-color: #fff;
  padding: 20px;
}

.modal-item {
  display: flex;
}
.modal-item > div {
  width: 50%;
  color: #606266;
}
.modal-item > div > .el-form-item {
  margin-bottom: 0;
}
/deep/ .el-carousel__container {
  height: 150px;
}
</style>
